module.exports = __webpack_public_path__ + "static/media/31JFA10.f03d9cf9.jpg";